import {useMemo} from "react";
import {TypeOf, z} from "zod";
import {useAccessToken} from "../auth";
import {useClientId} from "../ClientIdProvider";
import {createApiClientWithBaseConfig, Feature, get_QueryPlans, PlanCreation, PlanMutation} from "./client";

export function usePlanApi() {
	const accessToken = useAccessToken();
	const clientId = useClientId();
	return useMemo(() => createPlanApi(clientId, accessToken), [accessToken]);
}

export type PlanQuery = TypeOf<get_QueryPlans["parameters"]>["query"];

export const FeatureEnumValues: z.infer<typeof Feature>[] = Feature._def.options.map((feature) => feature._def.value);

function createPlanApi(clientId: string | undefined, accessToken: string | undefined) {
	const {api, withConfig} = createApiClientWithBaseConfig(clientId, accessToken);
	return {
		getPlan: (planId: number) =>
			api.get(
				"/api/plans/{planId}",
				withConfig({
					path: {planId},
				}),
			),
		queryPlans: (query: PlanQuery) =>
			api.get(
				"/api/plans",
				withConfig({
					query,
				}),
			),
		createPlan: (planCreation: PlanCreation) =>
			api.post(
				"/api/plans",
				withConfig({
					body: planCreation,
				}),
			),
		updatePlan: (planId: number, planMutation: PlanMutation) =>
			api.put(
				"/api/plans/{planId}",
				withConfig({
					path: {planId},
					body: planMutation,
				}),
			),
		deletePlan: (planId: number) =>
			api.delete(
				"/api/plans/{planId}",
				withConfig({
					path: {planId},
				}),
			),
	};
}
